export const applyInkWashStyle = async (canvas, ctx, setMessage, language) => {
  // 수묵화: 먹과 물의 번짐 효과
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 1. 그레이스케일 변환
  for (let i = 0; i < data.length; i += 4) {
    const gray = Math.round(0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]);
    data[i] = gray;
    data[i + 1] = gray;
    data[i + 2] = gray;
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 먹의 농도 조절 (4단계)
  const inkLevels = [255, 180, 100, 30]; // 흰색, 연한 회색, 진한 회색, 거의 검은색
  const inkData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const inkPixels = inkData.data;
  
  for (let i = 0; i < inkPixels.length; i += 4) {
    const brightness = inkPixels[i];
    let inkLevel;
    
    if (brightness > 200) {
      inkLevel = inkLevels[0]; // 흰색 (종이)
    } else if (brightness > 130) {
      inkLevel = inkLevels[1]; // 연한 먹
    } else if (brightness > 70) {
      inkLevel = inkLevels[2]; // 진한 먹
    } else {
      inkLevel = inkLevels[3]; // 매우 진한 먹
    }
    
    inkPixels[i] = inkLevel;
    inkPixels[i + 1] = inkLevel;
    inkPixels[i + 2] = inkLevel;
  }
  
  ctx.putImageData(inkData, 0, 0);
  
  // 3. 물 번짐 효과
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  const bleedData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const bleedPixels = bleedData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 방향성 있는 블러 (붓질 방향)
  for (let y = 2; y < canvas.height - 2; y++) {
    for (let x = 2; x < canvas.width - 2; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      // 현재 픽셀이 어두운 경우 (먹이 있는 경우)
      if (tempData[pos] < 200) {
        // 주변으로 번짐 효과
        const bleedStrength = (200 - tempData[pos]) / 200;
        
        for (let dy = -2; dy <= 2; dy++) {
          for (let dx = -2; dx <= 2; dx++) {
            const distance = Math.sqrt(dx * dx + dy * dy);
            if (distance <= 2 && distance > 0) {
              const neighborPos = ((y + dy) * canvas.width + (x + dx)) * 4;
              const bleedAmount = bleedStrength * (1 - distance / 2) * 30;
              
              for (let c = 0; c < 3; c++) {
                bleedPixels[neighborPos + c] = Math.max(0, 
                  bleedPixels[neighborPos + c] - bleedAmount);
              }
            }
          }
        }
      }
    }
  }
  
  ctx.putImageData(bleedData, 0, 0);
  
  // 4. 종이 질감과 붓 자국
  const textureData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const texturePixels = textureData.data;
  
  for (let i = 0; i < texturePixels.length; i += 4) {
    // 종이 질감 (쌀종이 느낌)
    if (Math.random() > 0.97) {
      const paperTexture = (Math.random() - 0.5) * 20;
      for (let c = 0; c < 3; c++) {
        texturePixels[i + c] = Math.min(255, Math.max(0, texturePixels[i + c] + paperTexture));
      }
    }
    
    // 붓 터치 효과
    const x = (i / 4) % canvas.width;
    const y = Math.floor((i / 4) / canvas.width);
    
    if (x % 5 === 0 && texturePixels[i] < 180) {
      const brushStroke = Math.sin(y * 0.1) * 10;
      for (let c = 0; c < 3; c++) {
        texturePixels[i + c] = Math.min(255, Math.max(0, texturePixels[i + c] + brushStroke));
      }
    }
  }
  
  ctx.putImageData(textureData, 0, 0);
};